/* eslint-disable */
jQuery(window).scroll(() => {
  let heightContent = jQuery('.entry-post').height(),
    relatedContent = jQuery('.related-content'),
    scrollTop = jQuery(window).scrollTop();
  if (relatedContent.hasClass('is-clicked')) {
    return;
  }

  if (scrollTop >= heightContent * 0.75) {
    relatedContent
      .addClass('expanded');
  } else {
    relatedContent
      .removeClass('expanded');
  }
});

jQuery('.related-content .content').on('click', function () {
  jQuery(this).parents('.related-content').addClass('is-clicked').toggleClass('expanded');
});
